import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from './Avatar';
import { relativeTime } from '../utils/format';
import '../../../styles/parentPortal.css';

export default function StudentCard({ student }) {
  const lastActive = student.lastActivityAt ? relativeTime(student.lastActivityAt) : null;
  return (
    <Link
      to={`/family/students/${encodeURIComponent(student.studentId)}`}
      className="pp-card--interactive"
      style={{
        textDecoration: 'none',
        padding: 'var(--space-5)',
        color: 'var(--text-primary)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', marginBottom: 'var(--space-4)' }}>
        <Avatar name={student.displayName} color={student.avatarColor} size={48} />
        <div style={{ minWidth: 0, flex: 1 }}>
          <div
            style={{
              fontWeight: 'var(--text-panel-weight)',
              fontSize: 'var(--text-panel-size)',
              color: 'var(--text-primary)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {student.displayName}
          </div>
          {student.email && (
            <div
              style={{
                fontSize: 12,
                color: 'var(--text-tertiary)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {student.email}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 'var(--space-4)', marginBottom: 'var(--space-3)' }}>
        <Stat label="Courses" value={student.courseCount ?? 0} />
        <Stat label="Avg progress" value={`${student.averageProgressPercent ?? 0}%`} />
      </div>

      <div style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>
        {lastActive ? `Last active ${lastActive}` : 'No activity yet'}
      </div>
    </Link>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-primary)', lineHeight: 1.1 }}>
        {value}
      </div>
      <div
        style={{
          fontSize: 'var(--text-label-size)',
          fontWeight: 'var(--text-label-weight)',
          textTransform: 'uppercase',
          letterSpacing: 'var(--text-label-tracking)',
          color: 'var(--text-tertiary)',
          marginTop: 'var(--space-1)',
        }}
      >
        {label}
      </div>
    </div>
  );
}
